import { Injectable } from '@angular/core'
import { GbPaginatedResponse } from '@galabid/gb-dashboard/core/data-access'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import { UserAccountsEntity } from './user-accounts.models'

@Injectable({
  providedIn: 'root',
})
export class UserAccountsApiService extends GbApiService {
  loadUserAccounts(
    offset: number,
    searchTerm: string | undefined,
    ordering: string,
  ): Observable<GbPaginatedResponse<UserAccountsEntity>> {
    const params: any = {
      offset: offset,
      limit: this.appConfig.itemsPageSize,
      search: searchTerm,
      ordering: ordering,
    }
    const url = 'users/'
    return this.get<GbPaginatedResponse<UserAccountsEntity>>(url, { params })
  }

  archiveUser(uuid: string = ''): Observable<UserAccountsEntity> {
    const url = `users/${uuid}/anonymise/`
    return this.post<UserAccountsEntity>(url)
  }

  removeFromUnsubscribeList(uuid: string = ''): Observable<void> {
    const url = `users/${uuid}/remove-from-unsubscribe-list/`
    return this.post<void>(url)
  }
}
